import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default {
  trayModalItemBackground: Colors.blackTwo
}
